export default __webpack_public_path__ + "static/media/merge.4c6ca2a6.png";